import { createRefPath_event } from '../../firestoreData/appData/appRefPaths';

const rts = {
  handleUpdate_rating: 'handleUpdate_rating',
  handleResponse_rating: 'handleResponse_rating',
  handleUpdate_ratingManager: 'handleUpdate_ratingManager',
}

export const _collectionName = '_ratings'

export const ratingReducer = (state, action) => {

  const { pathViews } = state

  const { type } = action

  switch (type) {

    case rts.handleResponse_rating:
      return { ...state, ratings: action.data }

    case rts.handleUpdate_ratingManager:
      updateRatingManager(pathViews, action.itemKey, action.data, action.callback)
      return { ...state }

    case rts.handleUpdate_rating:
      updateRate(pathViews, action)
      return { ...state }
    default:
      return { ...state }
  }
}

export const ratingInitialState = (initState) => {
  return { ...initState }
};

export const ratingHandlers = (dispatch) => {
  return {
    handleUpdate_rating: (uid, currentRating, r, itemKey) => { dispatch({ type: rts.handleUpdate_rating, dispatch, uid, currentRating, r, itemKey }) },
    handleResponse_rating: (data) => { dispatch({ type: rts.handleResponse_rating, dispatch, data }) },
    handleUpdate_ratingManager: (itemKey, data, callback) => { dispatch({ type: rts.handleUpdate_ratingManager, dispatch, itemKey, data, callback }) },
  }
}

const updateRatingManager = async (pathViews, item_key, data, callback) => {
  if (pathViews && item_key && data) {
    const _updateRef2 = createRefPath_event(pathViews, [_collectionName, item_key])
    database_fns.update_docc({
      refPath: _updateRef2,
      data: data,
      callback
    })
  }
}

const updateRate = async (pathViews, action, callback) => {
  const { uid, currentRating, r, itemKey } = action ?? {}
  const { _itemKey, appUserRatings } = currentRating ?? {}
  let _appUserRatings = appUserRatings ?? {}
  if (pathViews && r) {
    _appUserRatings[uid] = r
    const dataToUpdate = { appUserRatings: _appUserRatings }
    if (_itemKey) {
      const _updateRef2 = createRefPath_event(pathViews, [_collectionName, _itemKey])
      database_fns.update_docc({
        refPath: _updateRef2,
        data: dataToUpdate,
        callback
      })
    } else {
      const _updateRef2 = createRefPath_event(pathViews, [_collectionName, itemKey])
      dataToUpdate.ratingActive = true
      database_fns.update_docc({
        refPath: _updateRef2,
        data: dataToUpdate,
        callback
      })
    }
  }
} 